import script from "./TimeSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./TimeSelector.vue?vue&type=script&lang=ts&setup=true"

import "./TimeSelector.vue?vue&type=style&index=0&id=a0369e8a&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0369e8a"]])

export default __exports__